"use server";

import { t } from "@/lib/i18n";
import { createClient } from "@/lib/supabase/server";
import { passwordResetRequestSchema } from "@/lib/validation/auth";

export interface ForgotPasswordState {
  error?: string;
  success?: string;
}

export async function requestPasswordReset(
  _prevState: ForgotPasswordState,
  formData: FormData,
): Promise<ForgotPasswordState> {
  const parsed = passwordResetRequestSchema.safeParse({
    email: formData.get("email"),
  });
  if (!parsed.success) {
    return { error: parsed.error.issues[0].message };
  }

  const appUrl = process.env.NEXT_PUBLIC_APP_URL ?? "http://localhost:3000";
  const supabase = await createClient();
  await supabase.auth.resetPasswordForEmail(parsed.data.email, {
    redirectTo: `${appUrl}/auth/callback?volgende=/wachtwoord-herstellen`,
  });

  // Altijd hetzelfde antwoord, ongeacht of het adres bestaat (geen enumeratie).
  return { success: t.auth.herstelVerstuurd };
}
